import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import React, { FC } from "react";
import { observer } from "mobx-react";
import { LeadResponderSettings } from "./components/LeadResponderSettings";

interface IProps {
  accountStore: UserAccountStore;
}

export const LeadResponder: FC<IProps> = observer(({ accountStore }) => {
  return <LeadResponderSettings accountStore={accountStore} />;
});
